<script lang="ts" setup>
import { GpTag, GpTooltip } from '@gportal/uikit';
import { useProjectStore } from 'gpcore-apikit/store/pinia/project';
import { computed, onMounted, ref } from 'vue';
import { ProjectMemberRole } from 'gpcore-grpc/gpcore/api/cloud/v1/project_pb';
import Sidebar from './Module.Sidebar.vue';
import HeaderProjectMenu from './header/HeaderProjectMenu.vue';
import HeaderUserMenu from './header/HeaderUserMenu.vue';

const projectStore = useProjectStore();
const projectUsage = computed(() => projectStore.projectUsage);
const projectId = computed(() => projectStore.projectId);
const isProjectOwner = computed(
  () => projectStore.currentUserMembership?.role === ProjectMemberRole.OWNER,
);

const isLoadingProjectUsage = ref(false);
const reloadProjectUsage = () => {
  if (projectId.value === null) {
    return;
  }

  isLoadingProjectUsage.value = true;
  try {
    projectStore.reloadUsageForCurrentProject();
  } catch (e) {
    // ignore
  } finally {
    isLoadingProjectUsage.value = false;
  }
};

onMounted(() => {
  reloadProjectUsage();
});
</script>

<template>
  <header
    class="tw-fixed tw-inset-x-0 tw-top-0 tw-z-10 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-bg-gp-midnight-2 tw-p-3 xl:tw-left-80 xl:tw-justify-end"
  >
    <Sidebar />

    <div class="tw-flex">
      <GpTooltip
        v-if="isProjectOwner"
        content="This is the total usage of the project from the 1st of the month until now."
        placement="bottom"
      >
        <GpTag
          class="tw-mr-4 tw-hidden tw-justify-center md:tw-flex"
          size="sm"
          outline
          tag-type="primary"
          style="min-width: 70px"
        >
          <div
            v-if="isLoadingProjectUsage"
            class="tw-size-full tw-animate-pulse tw-rounded tw-bg-gp-cyan"
          ></div>

          <template v-else-if="projectUsage && projectUsage.total">
            {{ projectUsage.total.formatted }}
          </template>

          <template v-else> No usage </template>
        </GpTag>
      </GpTooltip>

      <HeaderProjectMenu v-if="projectId" />

      <HeaderUserMenu />
    </div>
  </header>
</template>
